import {
    SET_WORKFLOW_ACTIVE_PRACTICE,
    SET_WORKFLOW_PIMS,
    SET_WORKFLOW_ACTIVE_PRACTICE_ID,
    SET_WORKFLOW_PRACTICES,
    SET_WORKFLOW_FILTER,
    SET_WORKFLOW_STATUS,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const setWorkflowFilter = (filter='') => {
        return {
            type: SET_WORKFLOW_FILTER,
            payload: filter,
        }
    };
    
    const setWorkflowStatus = (status) => {
        if(!status) status = {
            loading: false,
            searchingPractices: true,
            editingPractice: false,
            editingRelations: false,
        };
        return {
            type: SET_WORKFLOW_STATUS,
            payload: status,
        }
    };

    const getPractices =
        (filter = '') =>
        async (dispatch) => {
            const params = { filter: filter };
            const res = await axiosCall.get('practices/workflow/practices', { params });
            dispatch(setWorkflowPractices(res.data));
            return res;
        };

    // Pulled this over from practices so that the featrue state is together
    const getPractice = (id) =>
        async (dispatch) => {
            let params = {getForWorkflow:true};
            let res = await axiosCall.get('practices/' + id, { params: params });
            dispatch(setWorkflowWorkingPractice(res.data.data));
            return res;
        };

    const setWorkflowPractices = (practices = []) => {
        return {
            type: SET_WORKFLOW_PRACTICES,
            payload: practices,
        };
    };
    
    const setWorkflowWorkingPractice = (practice) => {
        return {
            type: SET_WORKFLOW_ACTIVE_PRACTICE,
            payload: practice,
        };
    };

    const setWorkflowPims = (pims) => {
        return {
            type: SET_WORKFLOW_PIMS,
            payload: pims,
        };
    };

    const getWorkflowPractice = (practiceId = null) => {
        return async (dispatch) => {
            try {
                var response = {};
                if (practiceId === null) {
                    response = await axiosCall.get(
                        `practices/workflow/practices/empty`
                    );
                } else {
                    response = await axiosCall.get(
                        `practices/workflow/practices/${practiceId}`
                    );
                }
                dispatch(
                    setWorkflowWorkingPractice(response.data.data.practice)
                );
                dispatch(setWorkflowPims(response.data.data.pims));
                return response.data.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const setWorkflowPracticeId = (id) => {
        return {
            type: SET_WORKFLOW_ACTIVE_PRACTICE_ID,
            payload: id,
        };
    };

    const saveWorkflowPractice = (practice) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `practices/workflow/practices`,
                    practice
                );
                dispatch(setWorkflowPracticeId(response.data.data));
                return response.data.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const activateWorkflowPractice = (practiceId) => {
        return async (dispatch) => {
            try {
                await axiosCall.patch(
                    `practices/workflow/toggle?practiceId=${practiceId}`
                );
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    const clearInvalidPractices = () => {
        return async (dispatch) => {
            try {
                await axiosCall.delete(`practices/workflow/practices`);
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    return {
        getPractices,
        getPractice,
        getWorkflowPractice,
        saveWorkflowPractice,
        activateWorkflowPractice,
        clearInvalidPractices,
        setWorkflowFilter,
        setWorkflowStatus,
        setWorkflowWorkingPractice,
    };
};

export default initActions;
